__turbopack_context__.v({
  "className": "caveat_585bcf7c-module__jCjaQG__className",
});
